import { type ReactElement } from 'react';

import { EmojiPicker } from 'frimousse';

import { ButtonIcon } from '@spotify-internal/encore-web';
import { Popover, PopoverRoot } from '@spotify-internal/encore-web/next';

import styles from './EmojiPickerPopover.module.css';

export interface EmojiPickerPopoverProps {
  icon: ReactElement;
  onEmojiSelect?: (emoji: string) => void;
}

export const EmojiPickerPopover = ({
  icon,
  onEmojiSelect,
}: EmojiPickerPopoverProps) => (
  <PopoverRoot>
    <ButtonIcon
      type="button"
      variant="tertiary"
      size="small"
      semanticColor="textSubdued"
      aria-label="Add reaction"
      data-track-id="button.emoji-picker"
      data-track-action="expand"
    >
      {icon}
    </ButtonIcon>
    <Popover
      placement="top"
      hasNoArrow
      width="calc(320px + 2 * var(--encore-spacing-base))"
    >
      {({ close }) => (
        <EmojiPicker.Root
          className={styles.picker}
          onEmojiSelect={emoji => {
            onEmojiSelect?.(emoji.emoji);
            close();
          }}
        >
          <EmojiPicker.Search
            className={styles.search}
            placeholder="Search emoji…"
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus
          />
          <EmojiPicker.Viewport className={styles.viewport}>
            <EmojiPicker.Loading className={styles.status}>
              Loading…
            </EmojiPicker.Loading>
            <EmojiPicker.Empty className={styles.status}>
              No emoji found.
            </EmojiPicker.Empty>
            <EmojiPicker.List className={styles.list} />
          </EmojiPicker.Viewport>
        </EmojiPicker.Root>
      )}
    </Popover>
  </PopoverRoot>
);
